import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ExtendedUserDto } from 'core/api';
import {LLoginType, ScreenUtilsService} from 'core/services';
import { BehaviorSubject, take } from 'rxjs';
import { DataGridComponent } from '../../shared-components/data-grid/data-grid.component';
import { PageBaseDirective } from '../../shared-components/page-base.directive';
import { UserManagementService } from './user-management.service';
import {ConfigService} from "core/config";

@Component({
  selector: 'ss-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  host: {
    class: 'display-block padding-standard full-height'
  },
  hostDirectives: [PageBaseDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserManagementComponent {

  readonly designerLogin = this._configService.appConfig.designerLogin;
  readonly isDesignerLoginUserPassword = this.designerLogin === ('userPassword' as LLoginType);

  readonly showSearchSubject = new BehaviorSubject<boolean>(false);

  @ViewChild('gridRef')
  private _gridRef: DataGridComponent



  readonly load = this._userManagementService.load;
  readonly customizeRow = this._userManagementService.customizeRow;

  readonly columns = this._userManagementService.columns;
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs

  constructor(
    private readonly _userManagementService: UserManagementService,
    private readonly _screenUtilsService: ScreenUtilsService,
    private readonly _configService: ConfigService
  ) {
  }

  routeToUser(user: ExtendedUserDto) {
    this._userManagementService.routeToUser(user)
  }

  routeToNewUser() {
    this._userManagementService.routeToNewUser();
  }


  deleteUser(userDto: ExtendedUserDto) {
    this._userManagementService.deleteUser(userDto)
      .pipe(take(1))
      .subscribe(() => {
        this._gridRef?.refresh()
      })
  }

  importUsers() {
    this._userManagementService.importUsers()
      .subscribe(() => {
        this._gridRef.refresh();
      })
  }
}
